import { getPosition, isDesktop } from '../utils';

export default class ConvertHeight {
  constructor(elements, equalRootElement = false) {
    this.elements = $(elements);
    this.equalRootElement = equalRootElement || false;
    this.classesHeightChild = '.js-height-item';
    this.timeout = null;
    this.groupsSameOffsetTop = {};
  }

  initialize() {
    this.groupSameOffsetTop();
    this.convertHeight();
    $(window).on('resize orientationchange', () => {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.groupSameOffsetTop();
        this.convertHeight();
      }, 100);
    });
  }

  groupSameOffsetTop() {
    this.elements.each((_index, el) => {
      const element = $(el);
      const childElement = element.find(this.classesHeightChild);
      const offsetTop = isDesktop() ? getPosition(el).y : element.offset().top;

      if (!this.groupsSameOffsetTop[offsetTop]) {
        this.groupsSameOffsetTop[offsetTop] = [];
      }

      this.groupsSameOffsetTop[offsetTop].push(this.equalRootElement ? element : childElement);
    });
  }

  convertHeight() {
    Object.values(this.groupsSameOffsetTop).forEach((group) => {
      if (group.length > 1) {
        const heights = group.map((el) => {
          el.height('auto');
          return el.height();
        });

        const maxHeight = Math.max(...heights);
        group.forEach((el) => el.height(maxHeight));
      }
    });
  }
}
